module.exports = __webpack_public_path__ + "static/media/norma_tours_thumb.2ac17edd.jpg";